module.exports = __webpack_public_path__ + "static/media/ra_logo.ea5d048b.png";